import { render, staticRenderFns } from "./TrueAdvice.vue?vue&type=template&id=2e6db98c&"
import script from "./TrueAdvice.vue?vue&type=script&lang=js&"
export * from "./TrueAdvice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports